import ApiClient from "@/hooks/ApiClient";
export const authApi = {
	_register,
	_login,
	_forgotPassword,
	_verifyOtpCode,
	_resetPassword,
	_resendOtpCode,
};
async function _register(form_data) {
	return ApiClient.post(`/auth/register`, form_data)
		.then((response) => response.data)
		.catch((error) => {
			throw error.response ? error.response.data : error;
		});
}

async function _login(form_data) {
	return ApiClient.post(`/auth/login`, form_data)
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			throw error.response ? error.response.data : error;
		});
}

async function _forgotPassword(form_data) {
	return ApiClient.post(`/auth/forgot-password`, form_data)
		.then((response) => response.data)
		.catch((error) => {
			throw error.response ? error.response.data : error;
		});
}
async function _verifyOtpCode(form_data) {
	return ApiClient.post(`/auth/verify-otp-code`, form_data)
		.then((response) => response.data)
		.catch((error) => {
			throw error.response ? error.response.data : error;
		});
}
async function _resetPassword(form_data) {
	return ApiClient.post(`/auth/reset-password`, form_data)
		.then((response) => response.data)
		.catch((error) => {
			throw error.response ? error.response.data : error;
		});
}
async function _resendOtpCode(form_data) {
	return ApiClient.post(`/auth/resend-otp-code`, form_data)
		.then((response) => response.data)
		.catch((error) => {
			throw error.response ? error.response.data : error;
		});
}
